import { useNavigate } from "react-router";
import { fetchToken, setToken } from "./Auth";
import { useEffect, useState } from "react";
import axios from "axios";
import { TitleImage, InputTextField } from "./BaseComponents";

export default function Login() {
  const navigate = useNavigate();

  const [Userparams, setUserparams] = useState({});
  const handleFormChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setUserparams(values => ({...values, [name]: value}))
  }



  const signup = () => {
    navigate("/signup");
  };

  //check to see if the fields are not empty
  const login = () => {
    // check if already logged int
    if (fetchToken()) {
      navigate("/profile");
    } else if ((Userparams.username === "") || (Userparams.password === "")) {
      return;
    } else {
      // make api call to our backend. we'll leave this for later
      axios.post("/api/login", {
          username: Userparams.username,
          password: Userparams.password,
        })
        .then(function (response) {
          if (response.data.access_token) {
            setToken(Userparams.username, response.data.token);
            navigate("/profile");
          }
        })
        .catch(function (error) {
          console.log(error, "login error");
        });
    }
  };

  // Avoid going to the login page if you are already logged in
  useEffect((navigate) => {
  if (fetchToken()) {
    navigate("/profile");
  };
  }, []);

  return (
    <div className="App-body">
      {TitleImage()}
      <div className="ContentBorder">
        <form className="Form">
          <div className="Form-fields">
            {InputTextField("username","username",Userparams.username,handleFormChange)}
            {InputTextField("password","password",Userparams.password,handleFormChange)}
            <button type="button" onClick={login}>
              login
            </button>
            <br/>
            <p>problems logging in?</p>
            <button type="button" onClick={signup}>
              signup
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}